module.exports = __webpack_public_path__ + "img/9788989571131.af7a8a5d.jpg";